import {api} from './api'

export default (product) => {
    return {
        products: false,
        product: product,
        loading: false,
        loadingOems: false,
        oems: false,
        qty: 1,
        async searchEchiv(sku) {
            this.oems = false
            this.products = false;
            this.loading = true
            this.loadingOems = false
            api.get('custom/search/search&search=' + sku).then(async data => {
                this.products = await data.json()
                this.loading = false
            });

        },
        echivProducts(product_id) {
            if (typeof this.products.products !== 'undefined') {
                return this.products.products.filter((prod) => prod.product_id !== product_id)
            }
        },
        async productOems(product) {
            this.products = false;
            this.loadingOems = true
            api.get('custom/search/oems&search=' + product.clean_sku).then(async data => {
                if (product) {
                    this.loading = false;
                    this.oems = true
                    this.loadingOems = false
                    const {products} = await data.json()
                    this.products = products
                }
            });
        }
    }
}